const hasSelectedFilters = state =>
  Object.values(state.selectedFilters).filter(filter => filter?.length).length

export default {
  hasSelectedFilters
}
